// Attach event listener to elements with the class 'ajax-add-to-cart'
document.addEventListener("click", function (event) {
  // Check if the clicked element or any of its parents has the 'ajax-add-to-cart' class
  const button = event.target.closest(".ajax-add-to-cart");
  if (button) {
    // Add the 'loading' class to the button
    button.classList.add("loading");
    // Find and show the loading spinner by removing the 'hidden' class
    const loadingSpinner = button.querySelector(".loading__spinner");
    if (loadingSpinner) {
      loadingSpinner.classList.remove("hidden");
    }
    const ajaxVariantID = button.getAttribute("data-variantId");
    const quantityInput = document.getElementById(`quantity-${ajaxVariantID}`);
    // Default quantity to 1 if quantityInput is null
    const ajaxVariantQty = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    addToCartJS(ajaxVariantQty, ajaxVariantID, button);
  }
});

function addToCartJS(qty, variantID, btn) {
  // Open the cart drawer
  const cartDrawer = document.querySelector("cart-drawer");
  const sectionsToRender = cartDrawer
    .getSectionsToRender()
    .map((section) => section.id);
  const sections_url = window.location.pathname;

  // Send request to add item to cart
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      quantity: qty,
      id: variantID,
      sections: sectionsToRender,
      sections_url: sections_url,
    }),
  })
    .then((response) => response.json())
    .then((response) => {
      cartDrawer.renderContents(response);
      cartDrawer.open();
      // Remove the 'loading' class from the button
      btn.classList.remove("loading");

      // Hide the loading spinner by adding the 'hidden' class
      const loadingSpinner = btn.querySelector(".loading__spinner");
      if (loadingSpinner) {
        loadingSpinner.classList.add("hidden");
      }
      if (cartDrawer && cartDrawer.classList.contains("is-empty")) {
        cartDrawer.classList.remove("is-empty");
      }
    })
    .catch((error) => {
      console.error("Error adding item to cart:", error);
    });
}



document.addEventListener("DOMContentLoaded", function () {
  const productTitles = document.querySelectorAll(".productname-title");

  productTitles.forEach(function (productTitle) {
    const fullContent = productTitle.innerHTML;
    const charLimit = 25;

    if (fullContent.length > charLimit) {
      const truncatedContent = fullContent.substring(0, charLimit) + "...";
      productTitle.innerHTML = truncatedContent;

      const readMoreButton = document.createElement("span");
      readMoreButton.classList.add("read-more");
      readMoreButton.textContent = "Read More";
      productTitle.insertAdjacentElement("afterend", readMoreButton);

      readMoreButton.addEventListener("click", function () {
        if (productTitle.classList.contains("full")) {
          productTitle.classList.remove("full");
          readMoreButton.textContent = "Read More";
          productTitle.innerHTML = truncatedContent;
        } else {
          productTitle.classList.add("full");
          readMoreButton.textContent = "Read Less";
          productTitle.innerHTML = fullContent;
        }
      });
    }
  });
});


// DESKTOP & MOBILE JS START

var shopify_responsive_current_width = window.innerWidth;
var shopify_responsive_min_width = 992;
var shopify_responsive_mobile = shopify_responsive_current_width < shopify_responsive_min_width;

if (shopify_responsive_mobile) {
  convertToMobile();
}

window.addEventListener('resize', function () {
  var _mw = shopify_responsive_min_width;
  var _w = window.innerWidth;
  var desktopContent = document.querySelector("[id^='_desktop_']")?.innerHTML.trim().length > 0;
  var mobileContent = document.querySelector("[id^='_mobile_']")?.innerHTML.trim().length > 0;

  if (_w < _mw && desktopContent) {
    convertToMobile();
  } 
  if (_w >= _mw && mobileContent) {
    convertToDesktop();
  } 
});

function convertToMobile() {
  // Interchange sections
  document.querySelectorAll("[id^='_desktop_']").forEach(function (element) {
    var target = document.getElementById(element.id.replace('_desktop_', '_mobile_'));
    if (target) {
      swapElements(element, target);
    }
  });
}

function convertToDesktop() {
  // Interchange sections
  document.querySelectorAll("[id^='_mobile_']").forEach(function (element) {
    var target = document.getElementById(element.id.replace('_mobile_', '_desktop_'));
    if (target) {
      swapElements(element, target);
    }
  });

  var mainMediaContainer = document.getElementById('main-media-container');
  if (mainMediaContainer) {
    var image = mainMediaContainer.querySelector('img');
    if (image) {
      // You may need a custom zoom library here to replace `elevateZoom`
      console.log("Implement zoom functionality here for", image);
    }
  }
}

function swapElements(source, destination) {
  var sourceChildren = Array.from(source.children);
  var destinationChildren = Array.from(destination.children);

  destination.innerHTML = '';
  source.innerHTML = '';

  destinationChildren.forEach(function (child) {
    source.appendChild(child);
  });

  sourceChildren.forEach(function (child) {
    destination.appendChild(child);
  });
}

// DESKTOP & MOBILE JS END

// DROPDOWN TOGGLE JS START

document.addEventListener('DOMContentLoaded', function () {
  const dropdownToggle = document.getElementById('dropdown-toggle');
  const dropdownContent = document.querySelector('.dropdown-content');
  const toggleIcon = document.querySelector('.toggle-icon');

  if (dropdownToggle && dropdownContent && toggleIcon) {
    dropdownToggle.addEventListener('click', function () {
      if (dropdownContent.style.display === 'block') {
        dropdownContent.style.display = 'none';
        toggleIcon.classList.remove('active');
      } else {
        dropdownContent.style.display = 'block';
        toggleIcon.classList.add('active');
      }
    });
  } 
  // else {
  //   console.error('Required elements are missing from the DOM.');
  // }
});

// DROPDOWN TOGGLE JS END

// USER INFO POPUP JS START

// document.querySelectorAll(".user_info").forEach(function(userInfo) {
//   userInfo.addEventListener("click", function() {
//     document.querySelector(".usertoggle-dropdown").classList.add("active");
//     document.querySelector(".user-overlay").classList.add("active");
//     document.body.classList.add("overflow-hidden");

//     // Select the element
//     const headerGroup = document.querySelector('.shopify-section-group-header-group');
    
//     // Check if the element exists
//     if (headerGroup) {
//       // Set the z-index to 0
//       headerGroup.style.zIndex = '0';
//     }
//   });
// });

// document.querySelector("#Close-user").addEventListener("click", function() {
//   document.querySelector(".usertoggle-dropdown").classList.remove("active");
//   document.querySelector(".user-overlay").classList.remove("active");
//   document.body.classList.remove("overflow-hidden");

//   const headerGroup = document.querySelector('.shopify-section-group-header-group');
  
//   // Check if the element exists
//   if (headerGroup) {
//     // Set the z-index to 0
//     headerGroup.style.zIndex = '4';
//   }
// });

// document.querySelector(".user-overlay").addEventListener("click", function() {
//   document.querySelector(".usertoggle-dropdown").classList.remove("active");
//   this.classList.remove("active");
//   document.body.classList.remove("overflow-hidden");
//   const headerGroup = document.querySelector('.shopify-section-group-header-group');
    
//   // Check if the element exists
//   if (headerGroup) {
//     // Set the z-index to 0
//     headerGroup.style.zIndex = '4';
//   }
// });

// document.querySelectorAll('[data-action="ishi-panel"]').forEach(function (element) {
//   element.addEventListener('click', function () {
//     // Get the value of aria-controls
//     const targetId = this.getAttribute('aria-controls').replace('#', '');

//     // Show the element with the corresponding ID and hide others
//     document.querySelectorAll('.ishi-panel-data').forEach(function (panel) {
//       if (panel.id === targetId) {
//         panel.classList.add("active"); // Show the matching panel
//       } else {
//         panel.classList.remove("active"); // Hide other panels
//       }
//     });
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  const closeBtn = document.querySelector("#Close-user");
  const dropdown = document.querySelector(".usertoggle-dropdown");
  const overlay = document.querySelector(".user-overlay");
  const headerGroup = document.querySelector('.shopify-section-group-header-group');

  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation(); // Event bubbling ko roke

      dropdown?.classList.remove("active");
      overlay?.classList.remove("active");
      document.body.classList.remove("overflow-hidden");

      if (headerGroup) {
        headerGroup.style.zIndex = '4';
      }
    });
  }

  document.querySelectorAll(".user_info").forEach(function(userInfo) {
    userInfo.addEventListener("click", function(e) {
      e.stopPropagation(); // Event bubbling ko roke

      dropdown?.classList.add("active");
      overlay?.classList.add("active");
      document.body.classList.add("overflow-hidden");

      if (headerGroup) {
        headerGroup.style.zIndex = '0';
      }
    });
  });

  overlay?.addEventListener("click", function(e) {
    e.stopPropagation(); // Event bubbling ko roke

    dropdown?.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("overflow-hidden");

    if (headerGroup) {
      headerGroup.style.zIndex = '4';
    }
  });
  document.querySelectorAll('[data-action="ishi-panel"]').forEach(function (element) {
    element.addEventListener('click', function () {
      const targetId = this.getAttribute('aria-controls').replace('#', '');

      document.querySelectorAll('.ishi-panel-data').forEach(function (panel) {
        if (panel.id === targetId) {
          panel.classList.add("active");
        } else {
          panel.classList.remove("active");
        }
      });
    });
  });
});

// USER INFO POPUP JS END



 document.addEventListener("DOMContentLoaded", function () {
      const zoomImage = document.getElementById("zoomImage");

      zoomImage.addEventListener("mousemove", function (event) {
          let rect = zoomImage.getBoundingClientRect();
          let x = (event.clientX - rect.left) / rect.width * 100;
          let y = (event.clientY - rect.top) / rect.height * 100;

          zoomImage.style.transformOrigin = `${x}% ${y}%`;
          zoomImage.style.transform = "scale(2)"; /* Adjust zoom level */
      });

      zoomImage.addEventListener("mouseleave", function () {
          zoomImage.style.transform = "scale(1)";
      });
  });


// Shopby Dyagram Sorting

 document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelectorAll(".product-id");
    const parent = container[0]?.parentNode;
    // Convert NodeList to array for sorting
    const itemsArray = Array.from(container);
    // Sort by number inside `.ref span`
    itemsArray.sort(function (a, b) {
      const numA = parseInt(a.querySelector(".ref span").textContent.trim(), 10);
      const numB = parseInt(b.querySelector(".ref span").textContent.trim(), 10);
      return numA - numB; // For ascending order
    });
    // Re-append sorted items to the parent
    itemsArray.forEach(item => {
      parent.appendChild(item);
    });
  });



// product page wrapper div 
document.addEventListener("DOMContentLoaded", function () {
  var div1 = document.querySelector(".template-product variant-selects");

  // Only proceed if .variant-selects exists
  if (div1) {
    var div2 = document.querySelector(".template-product .product-form__quantity");

    if (div2) {
      var wrapper = document.createElement("div");
      wrapper.className = "combined-variant-selects";

      // Insert wrapper before div1
      div1.parentNode.insertBefore(wrapper, div1);

      // Move both divs into wrapper
      wrapper.appendChild(div1);
      wrapper.appendChild(div2);
    }
  }
});